import { Github, Linkedin, Mail, Briefcase } from 'lucide-react';

export const CONTACT = {
    email: 'benhendayoussef1@gmail.com',
    phone: '+216 99049471',
    cv: '/cv.pdf',
    github: 'https://github.com/benhendayoussef',
    linkedin: 'https://www.linkedin.com/in/youssef-ben-henda-384116240',
    upwork: 'https://www.upwork.com/freelancers/~benhendayoussef',
};

export const SOCIALS = [
    { key: 'github', label: 'GitHub', href: CONTACT.github, Icon: Github },
    { key: 'linkedin', label: 'LinkedIn', href: CONTACT.linkedin, Icon: Linkedin },
    { key: 'mail', label: 'Email', href: `mailto:${CONTACT.email}`, Icon: Mail },
    { key: 'upwork', label: 'Upwork', href: CONTACT.upwork, Icon: Briefcase },
];

// Section anchors, in page order — shared by the navbar and the footer.
export const NAV_LINKS = [
    { key: 'home', href: '#Home' },
    { key: 'about', href: '#About' },
    { key: 'services', href: '#Services' },
    { key: 'projects', href: '#Projects' },
    { key: 'experience', href: '#Experience' },
    { key: 'education', href: '#Education' },
    { key: 'blog', href: '#Blog' },
    { key: 'contact', href: '#Contact' },
];
